import { useState, useEffect } from 'react';
import { ErrorMessage } from '~/components/error-message';
import { fetchLMIProofDocs } from '~/services';
import { FetchFunnelPacketResponse } from '~/services/fetch-funnel-packet';
import { FetchLMIProofDocsResponse } from '~/services/fetch-lmi-proof-docs';
import { ProofDocDisplay } from './proof-doc-display.component';

interface ProofDocDisplayWrapperProps {
  funnelPacket: FetchFunnelPacketResponse;
}

export const ProofDocDisplayWrapper = (props: ProofDocDisplayWrapperProps) => {
  const { funnelPacket } = props;
  const userId = funnelPacket?.user?.id;
  const [proofDocResponse, setProofDocResponse] = useState<FetchLMIProofDocsResponse>({
    lmiProofDocs: [],
  });
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProofDocs = async () => {
      try {
        setLoading(true);
        setError(null);
        if (userId) {
          const response = await fetchLMIProofDocs({ id: userId });
          if (response.lmiProofDocs.length > 0) {
            setProofDocResponse(response);
          }
        }
        setLoading(false);
      } catch (error) {
        setError(new Error('Something went wrong. Please try again'));
      }
    };
    fetchProofDocs();
  }, [userId]);

  const proofDocData =
    proofDocResponse?.lmiProofDocs.map(doc => ({
      proofDocUrls: doc.proofDocUrls || [],
      proofDocName: doc.proofDocName || '',
      proofDocStatus: doc.proofDocStatus || '',
      uaLmiSourceTypeId: doc.uaLmiSourceTypeId || 0,
      utilityAccountId: doc.utilityAccountId || 0,
      utilityAccountNumber: doc.utilityAccountNumber || '',
      utilityName: doc.utilityName || '',
    })) || [];

  return error ? (
    <ErrorMessage error={error.message} />
  ) : (
    <ProofDocDisplay lmiProofDocs={proofDocData} funnelPacket={funnelPacket} loading={loading} />
  );
};
